<template>
  <div class="box">
    <div class="text">
         <vuescroll :ops="ops">
            <div  class="content">
                <h5>Non-Professional Subscriber：</h5>
                <p>Any natural person who is NOT:</p>
                <p>(a) registered or qualified in any capacity with the SEC, the Commodities Futures Trading Commission, any state securities agency, any securities exchange or association or any commodities or futures contract market orassociation;</p>
                <p>(b) engaged as an "investment advisor" as that term is defined inSection 202(a)(11) of the Investment Advisors Act of 1940 (whether or not registered or qualified under that Act);or</p>
                <p>(c) employed by a bank or other organization exempt from registration under federal or state securities laws to perform functions that would require registration or qualification if such functions were performed for an organization notsoexempt.</p>
                
                <h5 style="margin-top:12px">Professional Subscriber：</h5>
                <p>All other persons who do not meet the definition of Non-Professional User.</p>
            </div>
        </vuescroll>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            ops: {
                bar: {
                 background: "#c7d0e1",
                 onlyShowBarOnScroll:false,
                 keepShow:true,
                },

            },
        }
    }
}
</script>

<style scoped>
.box {
    border: 1px solid #869bc6;
    border-radius: 10px;
    background: #f9faff;
}
.text {
    width: 447px;
    height: 408px;
    color: #193f63;
    /* overflow: hidden; */
}
.content {
    padding: 20px;
    font-size: 12px;
}
.text p {
    line-height: 21px;
}
.text h5{
    font-weight: bold;
    line-height: 21px;
    margin-top: 12px;
}
</style>